export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11308.fb21136c.jpg";